import { render, staticRenderFns } from "./FormMenu.vue?vue&type=template&id=490dc4d2&scoped=true"
import script from "./FormMenu.vue?vue&type=script&lang=js"
export * from "./FormMenu.vue?vue&type=script&lang=js"
import style0 from "./FormMenu.vue?vue&type=style&index=0&id=490dc4d2&prod&lang=less&scoped=true"
import style1 from "./FormMenu.vue?vue&type=style&index=1&id=490dc4d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490dc4d2",
  null
  
)

export default component.exports